export default __webpack_public_path__ + "static/media/assigningstudent.bb9bb9f7.svg";